// src/components/CredentialsBanner.js
import React from 'react';
import styled from 'styled-components';
import { Shield } from 'lucide-react'; // Using lucide-react for icons

const BannerWrapper = styled.div`
  background-color: #0C2340;
  padding: 15px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const BannerContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  max-width: 1200px;
  padding: 0 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
`;

const CredentialItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #AE9142;
  font-weight: 600;

  svg {
    color: #C99700;
  }
`;

const CredentialsBanner = () => {
    return (
        <BannerWrapper>
            <BannerContent>
                <CredentialItem>
                    <Shield size={24} />
                    <span>Licensed</span>
                </CredentialItem>
                <CredentialItem>
                    <Shield size={24} />
                    <span>Bonded</span>
                </CredentialItem>
                <CredentialItem>
                    <Shield size={24} />
                    <span>Insured</span>
                </CredentialItem>
            </BannerContent>
        </BannerWrapper>
    );
};

export default CredentialsBanner;